import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../common'
export const DOC = gql`
  ${common.gql.dms.data.fragments.variable.DOC}
  mutation CreateApp($input: AppInput!, $zoneId: ID!, $tenantId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        createApp(input: $input) {
          alias
          id
          name
          icon
          description
          createdBy
          sessionVariables {
            ...FragmentVariable
          }
          supportsFunctionalityConfiguration
          supportsScenarios
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateAppMutation,
    ents.core.admin.App,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'createApp',
        graphql.transformers.OUT.object({
          alias: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          description: transformers.PASS_THROUGH,
          createdBy: transformers.PASS_THROUGH,
          icon: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          id: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          name: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          // TODO: This probably should be removed
          scenarioVariables: () => [],
          sessionVariables: graphql.transformers.OUT.validate(
            graphql.transformers.OUT.list(
              common.gql.dms.data.fragments.variable.TRANSFORMER,
              { onNullish: 'remove' },
            ),
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
          supportsFunctionalityConfiguration: transformers.PASS_THROUGH,
          supportsScenarios: graphql.transformers.OUT.validate(
            transformers.PASS_THROUGH,
            TypeAsserter.assertIsNotNullish,
            { warnOnly: true },
          ),
        }),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.CreateAppMutation,
  ents.core.admin.App,
  graphql.schema.CreateAppMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
